import React, { useState } from 'react';
import Video from '../../videos/video.mp4';
import { HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroICP, HeroBtnWrapper, ArrowForward, ArrowRight  } from './HeroElements'
import {Button} from '../ButtonElement';

const HeroSection = () => {
    
    const [hover, setHover] = useState(false)
 
    const onHover = () => {
        setHover(!hover)
    }
    
    return (
        <HeroContainer>
            <HeroBg>
                <VideoBg autoPlay loop muted src={Video} type='video/mp4' />
            </HeroBg>
            <HeroContent>
                <HeroH1>以人工智能技术助力企业驱动全球视野</HeroH1>
                <HeroP>
                    Cloud AI for Global Vision
                </HeroP>
                <HeroBtnWrapper>
                    <Button to="signup" onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true'>
                        了解更多 {hover ? <ArrowForward /> : <ArrowRight/>}
                    </Button>
                </HeroBtnWrapper>
                <HeroICP>
                    
                </HeroICP>
            </HeroContent>
            
        </HeroContainer>
        
    )
}

export default HeroSection
